import { Button, TooltipDialog, InfoCircleHollowSVG } from "@newsela/angelou";
import PropTypes from "prop-types";
import FocusLock from "react-focus-lock";

import {
  closeIconCss,
  dialogContainerCss,
  infoButtonRootCss,
  infoIconCss,
  sharedStatusContainerCss,
  sharedStatusTextCss,
  shareStatusHeaderCss,
  tooltipTextCss,
} from "./AnnotationShareStatus.style";

const propTypes = {
  isShared: PropTypes.bool,
  hasReplies: PropTypes.bool,
};

const AnnotationShareStatus = ({ isShared, hasReplies }) => {
  const sharedAndHasRepliesText =
    "Students can view this annotation because it's been shared.\n\nThis annotation can't be unshared (but can still be deleted) because it has 1 or more student responses.";
  const sharedAndNoRepliesText =
    "Students can view this annotation because it's been shared. \n\nOnce a student responds to it, this annotation can't be unshared.";
  const unsharedStatusText =
    "Students can view an annotation after it's been shared. Once a student responds to it, an annotation can't be unshared.";

  const renderShareStatus = () => {
    if (!isShared) {
      return unsharedStatusText;
    } else if (hasReplies) {
      return sharedAndHasRepliesText;
    } else {
      return sharedAndNoRepliesText;
    }
  };
  return (
    <div css={sharedStatusContainerCss}>
      <TooltipDialog
        buttonProps={{
          flavor: Button.flavors.incognito,
          icon: {
            SvgComponent: InfoCircleHollowSVG,
          },
        }}
        __cssFor={{
          Button: {
            root: infoButtonRootCss,
            Icon: { root: infoIconCss },
          },
          dialog: {
            root: dialogContainerCss,
            Button: { Icon: { root: closeIconCss } },
            header: shareStatusHeaderCss,
          },
        }}
        body={
          <FocusLock>
            <p css={tooltipTextCss}>{renderShareStatus()}</p>
          </FocusLock>
        }
        // This allows for the dialog to only appear below the icon. Without this,
        // the tooltip automatically places it depending on the viewport. We don't want that to
        // happen because we want the tooltip to stay contained within the annotation card.
        fallbackPlacements={["bottom-end, left"]}
        header="Sharing"
        offset={8}
        placement="bottom-end"
      />
      <span css={sharedStatusTextCss}>{isShared ? "shared" : "unshared"}</span>
    </div>
  );
};

AnnotationShareStatus.propTypes = propTypes;
export default AnnotationShareStatus;
